import { AccountBucketInfo, WorkbookRecords, WorkbookUrl } from "./company-state";

export enum CompanyActionTypeEnum {
  SET_COMPANY_DETAILS = "SET_COMPANY_DETAILS",
  SET_WORKBOOK_RECORDS = "SET_WORKBOOK_RECORDS",
  SET_WORKBOOK_URL = "SET_WORKBOOK_URL",
  SET_ACCOUNT_MAPPINGS = "SET_ACCOUNT_MAPPINGS",
  RESET_TO_INITIAL_STATE = "RESET",
  IS_WORKBOOK_REFRESH_REQUIRED = "IS_WORKBOOK_REFRESH_REQUIRED",
  WORKBOOK_REFRESH_STATUS = "WORKBOOK_REFRESH_STATUS",
  SET_ACCOUNT_BUCKET_INFO = "SET_ACCOUNT_BUCKET_INFO",
  SET_UN_BUCKETED_ACCOUNTS = "SET_UN_BUCKETED_ACCOUNTS",
  SET_WARN_DIALOG_STATUS = "SET_WARN_DIALOG_STATUS",
  SET_TIMELINE_RECORDS="SET_TIMELINE_RECORDS",
  SET_CONFLICT_DETECTED_STATUS="SET_CONFLICT_DETECTED_STATUS",
  SET_CASH_ACCOUNT_FORM_TYPE="SET_CASH_ACCOUNT_FORM_TYPE",
  SET_LOAN_ACCOUNT_FORM_TYPE="SET_LOAN_ACCOUNT_FORM_TYPE",
  SET_LOAN_ACCOUNT_CONFLICT_DETECTED_STATUS="SET_LOAN_ACCOUNT_CONFLICT_DETECTED_STATUS",
  SET_ALL_COMPANY_LIST="SET_ALL_COMPANY_LIST",
  SET_PDS_ELIGIBLE_DETAILS="SET_PDS_ELIGIBLE_DETAILS",
  IS_PDS_DETAILS_UNAVAILABLE="IS_PDS_DETAILS_UNAVAILABLE"
}

export function setCompanyDetails(companyDetails: any) {
  return {
    type: CompanyActionTypeEnum.SET_COMPANY_DETAILS,
    data: companyDetails,
  };
}

export function setPdsEligibleStatus(pdsEligibilityDetails: any) {
  return {
    type: CompanyActionTypeEnum.SET_PDS_ELIGIBLE_DETAILS,
    data: pdsEligibilityDetails,
  };
}
export function updateIsPdsDetailsUnavailable(flag: boolean) {
  return {
    type: CompanyActionTypeEnum.IS_PDS_DETAILS_UNAVAILABLE,
    data: flag
  }
}

export function setAllCompanyList(companyList: any) {
  return {
    type: CompanyActionTypeEnum.SET_ALL_COMPANY_LIST,
    data: companyList,
  };
}

export function setWorkbookRecords(workbookRecords: any) {
  return {
    type: CompanyActionTypeEnum.SET_WORKBOOK_RECORDS,
    data: workbookRecords,
  };
}

export function setTimelineRecords(timelineRecords: any) {
  return {
    type: CompanyActionTypeEnum.SET_TIMELINE_RECORDS,
    data: timelineRecords,
  };
}

export function setWorkbookUrl(workbookUrl: WorkbookUrl, key: string) {
  return {
    type: CompanyActionTypeEnum.SET_WORKBOOK_URL,
    data: {
      presignedURL: workbookUrl.presignedURL,
      key: key,
    },
  };
}
export function setAccountMappings(accountMappings: any) {
  return {
    type: CompanyActionTypeEnum.SET_ACCOUNT_MAPPINGS,
    data: accountMappings,
  };
}

export function resetCompanyState() {
  return {
    type: CompanyActionTypeEnum.RESET_TO_INITIAL_STATE,
  };
}

export function updateWorkbookRefreshStatus(status: string) {
  return {
    type: CompanyActionTypeEnum.WORKBOOK_REFRESH_STATUS,
    data: status,
  };
}

export function updateIsWorkBookRefreshRequired(flag: boolean) {
  return {
    type: CompanyActionTypeEnum.IS_WORKBOOK_REFRESH_REQUIRED,
    data: flag,
  };
}

export function setAccountBucketInfo(idAndLabelMap: AccountBucketInfo) {
  return {
    type: CompanyActionTypeEnum.SET_ACCOUNT_BUCKET_INFO,
    data: idAndLabelMap,
  };
}

export function setUnBucketedAccounts(data: Map<string, string>) {
  return {
    type: CompanyActionTypeEnum.SET_UN_BUCKETED_ACCOUNTS,
    data,
  };
}

export function setWarningDialogStatus(flag: boolean) {
  return {
    type: CompanyActionTypeEnum.SET_WARN_DIALOG_STATUS,
    data: flag,
  };
}

export function setConflictDetectedStatus(flag: boolean) {
  return {
    type: CompanyActionTypeEnum.SET_CONFLICT_DETECTED_STATUS,
    data: flag,
  };
}

export function setCashAccountFormType(type: "EDIT" | "CONFIRMED") {
  return {
    type: CompanyActionTypeEnum.SET_CASH_ACCOUNT_FORM_TYPE,
    data: type,
  };
}


export function setLoanAccountFormType(type: "EDIT" | "CONFIRMED") {
  return {
    type: CompanyActionTypeEnum.SET_LOAN_ACCOUNT_FORM_TYPE,
    data: type,
  };
}

export function setLoanAccountConflictDetectedStatus(flag: boolean) {
  return {
    type: CompanyActionTypeEnum.SET_LOAN_ACCOUNT_CONFLICT_DETECTED_STATUS,
    data: flag,
  };
}
